import { db } from '@/config/firebase'
import dbFilter from '@/helpers/firestoreQueryFilter'

export default {
  async getCheckers({ commit, rootState }) {
    const companyId = rootState.User.profile.company_id

    let userRef = db
      .collection('companies')
      .doc(companyId)
      .collection('users')
      .orderBy('name')
      .where('roles', 'array-contains', 'checker')

    let checkers = await dbFilter.query(userRef)
    commit('changeCheckers', checkers)
    return checkers
  },
}
